export enum StepStatus {
    incomplete = 0,
    complete = 1,
    pending = 2,
    reopened = 3,
    awaiting_client = 4,
    skipped = 5,
    client_hold = 6,
    paused = 7,
    awaiting_missing_info = 21

}


